
export const GetCategoriesByCurrentCategory = (currentCategoryNodeId, api, productFilters, cancelToken) => {
    return api.post(`/api/v1/AssortCategories/GetCategoriesByCurrentCategory?currentCategoryNodeId=${currentCategoryNodeId}`, productFilters, { cancelToken: cancelToken });
}

export const GetCategoryNavigationTree = (api, currentCategoryNodeId, cancelToken) => {
    return api.get(`/api/v1/AssortCategories/GetCategoryNavigationTree?currentCategoryNodeId=${currentCategoryNodeId}`, { cancelToken: cancelToken })
}

export const GetCategoriesBySearchingProducts = (api, productFilters) => {
    return api.post(`/api/v1/AssortCategories/GetCategoriesBySearchingProducts`, productFilters)
}

export const GetCategoriesForHomePage = (api, cancelToken) => {
    return api.get(`/api/v1/AssortCategories/GetCategoriesForHomePage?allArticle=${false}`, { cancelToken: cancelToken })
}

export const GetRootCategories = (api, productFilters, cancelToken) => {
    return api.post(`/api/v1/AssortCategories/GetRootCategories`, productFilters, { cancelToken: cancelToken })
}
